import { Provider } from "react-redux";
import Posts from "./Posts/Posts";
import {BrowserRouter} from 'react-router-dom';
import store from "./store/store";
import './i18n'; // 导入 i18next 配置

function App() {
  return (
    <Provider store={store}>  {/* 用 Provider 包裹整个应用 */}
      <BrowserRouter>
        <Posts/>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
